import { combineReducers } from '@reduxjs/toolkit'
import subscriptionError from './subscription'

const error = combineReducers({
  subscriptionError,
})

export type ErrorState = ReturnType<typeof error>

export default error
